<div class="create-permit-dialog" role="dialog" aria-modal="true">
    <button class="back-button" (click)="goBack()" *ngIf="currentStep !== STEP_CREATED && currentStep !== STEP_REQUESTER" aria-label="Go back">
        <i class="icon-caret-left"></i>
    </button>
    <button class="close-dialog-button" (click)="closeDialog()">
        <i class="icon-close"></i>
    </button>

    <div class="dialog-header">
        <h1 class="dialog-header-text">{{ 'permit.create.title' | translate }}</h1>
    </div>

    <div class="stepper-container" *ngIf="currentStep !== STEP_CREATED">
        <ul class="stepper">
            <li
                class="step"
                [ngClass]="{ completed: STEP_REQUESTER < currentStep, active: STEP_REQUESTER === currentStep, clickable: STEP_REQUESTER < currentStep }"
                (click)="goToStep(STEP_REQUESTER)"
            >
                <span class="step-circle">
                    <i *ngIf="STEP_REQUESTER < currentStep" class="icon-check"></i>
                    <span *ngIf="STEP_REQUESTER === currentStep" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'permit.create.stepper.requester' | translate }}</span>
            </li>
            <li class="step" [ngClass]="{ completed: STEP_CATEGORY < currentStep, active: STEP_CATEGORY === currentStep, clickable: STEP_CATEGORY < currentStep }" (click)="goToStep(STEP_CATEGORY)">
                <span class="step-circle">
                    <i *ngIf="STEP_CATEGORY < currentStep" class="icon-check"></i>
                    <span *ngIf="STEP_CATEGORY === currentStep" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'permit.create.stepper.category' | translate }}</span>
            </li>
            <li class="step" [ngClass]="{ completed: STEP_TYPE < currentStep, active: STEP_TYPE === currentStep, clickable: STEP_TYPE < currentStep }" (click)="goToStep(STEP_TYPE)">
                <span class="step-circle">
                    <i *ngIf="STEP_TYPE < currentStep" class="icon-check"></i>
                    <span *ngIf="STEP_TYPE === currentStep" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'permit.create.stepper.permit_type' | translate }}</span>
            </li>
            <li class="step" [ngClass]="{ completed: STEP_LOCATION < currentStep, active: STEP_LOCATION === currentStep, clickable: STEP_LOCATION < currentStep }" (click)="goToStep(STEP_LOCATION)">
                <span class="step-circle">
                    <i *ngIf="STEP_LOCATION < currentStep" class="icon-check"></i>
                    <span *ngIf="STEP_LOCATION === currentStep" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'permit.create.stepper.location' | translate }}</span>
            </li>
            <li
                class="step"
                [ngClass]="{ completed: STEP_RESOURCES < currentStep, active: STEP_RESOURCES === currentStep, clickable: isStepReachable(STEP_RESOURCES) }"
                (click)="goToStep(STEP_RESOURCES)"
            >
                <span class="step-circle">
                    <i *ngIf="STEP_RESOURCES < currentStep" class="icon-check"></i>
                    <span *ngIf="STEP_RESOURCES === currentStep" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'permit.create.stepper.resources' | translate }}</span>
            </li>
            <li
                class="step"
                [ngClass]="{
                    completed: STEP_DETAILS < currentStep && currentStep !== STEP_REVIEW,
                    active: STEP_DETAILS === currentStep || currentStep === STEP_REVIEW,
                    clickable: currentStep === STEP_REVIEW
                }"
                (click)="goToStep(STEP_DETAILS)"
            >
                <span class="step-circle">
                    <i *ngIf="STEP_DETAILS < currentStep && currentStep !== STEP_REVIEW" class="icon-check"></i>
                    <span *ngIf="STEP_DETAILS === currentStep || currentStep === STEP_REVIEW" class="active-dot"></span>
                </span>
                <span class="step-label">{{ 'permit.create.stepper.details' | translate }}</span>
            </li>
        </ul>
    </div>

    <div class="dialog-content">
        <!-- ===== 0. REQUESTER ===== -->
        <div *ngIf="currentStep === STEP_REQUESTER" class="choose-citizen-step">
            <div class="step-header" *ngIf="!isCreatingCitizen">
                <h2 class="step-title">{{ 'permit.create.requester.title' | translate }}</h2>
                <p class="step-description">{{ 'permit.create.requester.helper' | translate }}</p>
            </div>
            <div class="step-header" *ngIf="isCreatingCitizen">
                <h2 class="step-title">{{ 'permit.create.requester.register_title' | translate }}</h2>
                <p class="step-description">{{ 'permit.create.requester.register_helper' | translate }}</p>
            </div>

            <div class="search-section" *ngIf="!isCreatingCitizen">
                <div class="current-user-section" *ngIf="currentUser" (click)="selectCurrentUser()">
                    <div class="user-card hoverable" [class.selected]="isCurrentUserSelected()">
                        <div class="user-avatar">
                            <img *ngIf="currentUser.picture" [src]="currentUser.picture" alt="" />
                            <div *ngIf="!currentUser.picture" class="default-avatar">
                                <i class="icon-user"></i>
                            </div>
                        </div>
                        <div class="user-details">
                            <div class="user-name">
                                {{ currentUser.firstName }} {{ currentUser.lastName }}
                                <span class="me-badge">{{ 'permit.create.requester.me' | translate }}</span>
                            </div>
                            <div class="user-email">{{ currentUser.email }}</div>
                            <div class="user-phone" *ngIf="currentUser.phone">{{ currentUser.phone }}</div>
                        </div>
                    </div>
                </div>

                <div class="divider-text" *ngIf="currentUser">
                    <span>{{ 'permit.create.requester.or_search' | translate }}</span>
                </div>

                <app-search-dropdown
                    [mode]="'single'"
                    [selectedUsers]="[]"
                    (usersSelected)="onCitizenSelected($event)"
                    [placeholder]="'permit.create.requester.search_placeholder' | translate"
                    [showCreateOption]="true"
                    [showRadio]="false"
                    (createOptionClicked)="onCitizenCreateClick($event)"
                ></app-search-dropdown>

                <div class="selected-user-summary" *ngIf="selectedCitizen && !isCurrentUserSelected()">
                    <div class="user-card selected">
                        <div class="user-avatar">
                            <img *ngIf="selectedCitizen.picture" [src]="selectedCitizen.picture" alt="" />
                            <div *ngIf="!selectedCitizen.picture" class="default-avatar">
                                <i class="icon-user"></i>
                            </div>
                        </div>
                        <div class="user-details">
                            <div class="user-name">{{ citizenName(selectedCitizen) }}</div>
                            <div class="user-email">{{ selectedCitizen.email }}</div>
                            <div class="user-phone" *ngIf="selectedCitizen.phone">{{ selectedCitizen.phone }}</div>
                        </div>
                        <button class="remove-user-btn" (click)="selectedCitizen = null">
                            <i class="icon-close"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="create-citizen-section" *ngIf="isCreatingCitizen">
                <form [formGroup]="newCitizenForm" (ngSubmit)="submitNewCitizen()" class="citizen-form">
                    <div class="form-row">
                        <div class="form-group half-width">
                            <label>{{ 'permit.create.requester.first_name' | translate }} *</label>
                            <input type="text" formControlName="firstName" />
                            <div class="error-message" *ngIf="newCitizenForm.get('firstName').touched && newCitizenForm.get('firstName').invalid">
                                {{ 'permit.create.errors.required' | translate }}
                            </div>
                        </div>
                        <div class="form-group half-width">
                            <label>{{ 'permit.create.requester.last_name' | translate }} *</label>
                            <input type="text" formControlName="lastName" />
                            <div class="error-message" *ngIf="newCitizenForm.get('lastName').touched && newCitizenForm.get('lastName').invalid">
                                {{ 'permit.create.errors.required' | translate }}
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'permit.create.requester.email' | translate }} *</label>
                        <input type="email" formControlName="email" />
                        <div class="error-message" *ngIf="newCitizenForm.get('email').touched && newCitizenForm.get('email').hasError('required')">
                            {{ 'permit.create.errors.required' | translate }}
                        </div>
                        <div class="error-message" *ngIf="newCitizenForm.get('email').touched && newCitizenForm.get('email').hasError('pattern') && !newCitizenForm.get('email').hasError('required')">
                            {{ 'permit.create.errors.email' | translate }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label>{{ 'permit.create.requester.phone' | translate }}</label>
                        <input type="tel" formControlName="phone" appPhoneMask />
                        <div
                            class="error-message"
                            *ngIf="newCitizenForm.get('phone').touched && (newCitizenForm.get('phone').hasError('minlength') || newCitizenForm.get('phone').hasError('maxlength'))"
                        >
                            {{ 'permit.create.errors.phone_invalid' | translate }}
                        </div>
                    </div>

                    <div class="citizen-form-actions">
                        <a class="back-link" (click)="cancelCitizenCreation()">{{ 'permit.create.requester.back_to_search' | translate }}</a>
                        <button type="submit" class="submit-citizen-btn" [disabled]="creatingCitizen">
                            <mat-spinner *ngIf="creatingCitizen" diameter="20"></mat-spinner>
                            <span *ngIf="!creatingCitizen">{{ 'permit.create.requester.register_button' | translate }}</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <!-- ===== 1. CATEGORY ===== -->
        <app-permit-category-step
            *ngIf="currentStep === STEP_CATEGORY"
            [categories]="categories"
            [loading]="loading"
            [selectedCategory]="selectedCategory"
            (categorySelected)="onCategorySelected($event)"
        ></app-permit-category-step>

        <!-- ===== 2. PERMIT TYPE ===== -->
        <app-permit-type-step
            *ngIf="currentStep === STEP_TYPE"
            [selectedCategory]="selectedCategory"
            [types]="currentTypes"
            [loading]="typesLoading"
            [selectedType]="selectedType"
            (typeSelected)="onTypeSelected($event)"
        ></app-permit-type-step>

        <!-- ===== 3. LOCATION ===== -->
        <app-permit-location-step
            *ngIf="currentStep === STEP_LOCATION"
            [selectedCategory]="selectedCategory"
            [selectedType]="selectedType"
            [citizenId]="requesterId"
            [initialLocation]="location"
            (locationChanged)="onLocationChanged($event)"
            (selectionStateChanged)="onLocationSelectionChanged($event)"
            (skipped)="skipLocation()"
        ></app-permit-location-step>

        <!-- ===== 4. RESOURCES ===== -->
        <app-permit-resources-step *ngIf="currentStep === STEP_RESOURCES" [files]="selectedType?.files || []"></app-permit-resources-step>

        <!-- ===== 5. DETAILS ===== -->
        <app-permit-details-step
            *ngIf="currentStep === STEP_DETAILS"
            [selectedType]="selectedType"
            [formSections]="selectedType?.formSections || []"
            [initialFormData]="detailsInitialFormData"
            [initialFiles]="detailsInitialFiles"
            (detailsChanged)="onDetailsChanged($event)"
            (filesChanged)="onDetailsFilesChanged($event)"
        ></app-permit-details-step>

        <!-- ===== 5. REVIEW ===== -->
        <app-permit-review-step
            *ngIf="currentStep === STEP_REVIEW"
            [citizen]="selectedCitizen"
            [selectedCategory]="selectedCategory"
            [selectedType]="selectedType"
            [location]="location"
            [formData]="formData"
            [fileNames]="fileNames"
        ></app-permit-review-step>

        <!-- ===== 6. CREATED ===== -->
        <app-permit-created
            *ngIf="currentStep === STEP_CREATED"
            [categoryName]="localizedName(selectedCategory?.name)"
            [typeName]="localizedName(selectedType?.name)"
            [typeSubtitle]="typeSubtitle(selectedType)"
            [permitId]="createdPermitId"
            (close)="closeCreated()"
        ></app-permit-created>
    </div>

    <div class="dialog-actions" [class.split]="currentStep === STEP_DETAILS" *ngIf="![STEP_CATEGORY, STEP_TYPE, STEP_CREATED].includes(currentStep)">
        <button *ngIf="currentStep === STEP_DETAILS" class="previous-button" (click)="goBack()">
            {{ 'permit.create.previous_button' | translate }}
        </button>
        <button *ngIf="[STEP_REQUESTER, STEP_LOCATION, STEP_RESOURCES, STEP_DETAILS].includes(currentStep)" class="next-button" [disabled]="!canProceed()" (click)="next()">
            {{ 'permit.create.next_button' | translate }}
        </button>
        <button *ngIf="currentStep === STEP_REVIEW" class="create-button" (click)="next()" [disabled]="submitting">
            <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
            {{ 'permit.create.create_button' | translate }}
        </button>
    </div>
</div>
